export default __webpack_public_path__ + "static/media/about--desktop@2x.c323f09b.webp";